module.exports = __webpack_public_path__ + "static/colorado-9a87db66fda87dff0fc514ef7fe8f8c7.png";